export default "__VITE_ASSET__BARF7xkq__"